import { render } from "./CurrentPointsView.vue?vue&type=template&id=48d341c8&scoped=true"
import script from "./CurrentPointsView.vue?vue&type=script&lang=js"
export * from "./CurrentPointsView.vue?vue&type=script&lang=js"

import "./CurrentPointsView.vue?vue&type=style&index=0&id=48d341c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d341c8"]])

export default __exports__